var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLogoStyleFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 26,
  viewBox: "0 0 33 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "flag original"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 49",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.4746H32.3604V0.500244H0V25.4746Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 51",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.79102 22.6788H14.7772V3.29358H2.79102V22.6788Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.582 22.6788H29.5682V3.29358H17.582V22.6788Z",
  fill: "white"
}))));
export default SvgIconLogoStyleFlag;